import React, { useCallback, useEffect, useState } from "react";
import "./CheckList.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft, faChevronRight, faCheckCircle, faEllipsisH, faExchangeAlt
} from "@fortawesome/free-solid-svg-icons";
import openLily from './assets/nufar-open.png'
import nufarS from './assets/nufarS.png'
import nufarL from './assets/nufarL.png'
import nufarEnd from './assets/nufarEnd-Test.png'
import nufarSTest from './assets/nufarS-Test.png'



import lotus from './assets/lotus-yellow.png'
import checkAlb from './assets/checkAlb.png'
import checkHover from './assets/checkHover.png'
import { useHistory } from "react-router-dom";
import { relative } from "path";



const buttons = [
  { id: 0, name: "INITIERA" },
  { id: 1, name: "SAMVERKA" },
  { id: 2, name: "ORGANISERA" },
  { id: 3, name: "VIDAREUTVECKLA" },
];

const horizontalDots = (
  <FontAwesomeIcon icon={faEllipsisH}></FontAwesomeIcon>
)

const lotusFlower = (<img height="150px" width="250px" src={lotus} alt="" />
)

const checkCircle = (
  <FontAwesomeIcon style={{ color: '#FFF8ED', fontSize: '35px' }} icon={faCheckCircle}></FontAwesomeIcon>
)

const doubleArrow = (
  <FontAwesomeIcon style={{ color: '#D8B86C', fontSize: '45px' }} icon={faExchangeAlt}></FontAwesomeIcon>
)


const leftIcon = (
  <FontAwesomeIcon
    style={{ fontSize: '18px', color: '#707070', marginRight: '7px' }}
    icon={faChevronLeft}
  />
);

const rightIcon = (
  <FontAwesomeIcon
    style={{ fontSize: '18px', color: '#707070', marginRight: '7px' }}
    icon={faChevronRight}
  />
);


const stepTitle = [
  "En idé initieras", "Vidareutveckla idén i samverkan med andra aktörer", "Samla kompetens och bilda en arbetsgrupp", "Vidareutveckla idén utifrån organisatoriska perspektiv samt användarperspektiv"
]

const stepDescription = [
  "Vem som helst kan ta initiativet till den nya idén.",
  "Fortsätta diskussioner med de indentifierade personerna från Steg 1 för att vidareutveckla idén.",
  "Målet är att fortsätta utveckla idén inom arbetsgruppen. Nuvarande och tänkt arbetssätt kan visualiseras genom tex flödesscheman eller tjänstedesign verktyg.",
  "Arbetsgrupp som består av deltagare från tidigare arbetsgrupp samt identifierade kompetenser från Steg 3."
]

const stepIntroduction = [
  "Startpunkten är en ny idé inom området välfärdsteknik. Vem som helst kan var upphovsman till idén, både inom och utanför organisationen. Under Steg 1 försöker man identifiera det problem som den idén är tänkt att lösa, de behov som idén ska fylla och vem som har behovet av idén. Här ska man också identifiera de aktörer som kan bidra till att vidareutveckla idén samt omvärldsbevaka om någon liknande idé har förverkligats någon annanstans, inom eller utanför den egna organisationen.",
  "Här möts aktörerna som identifierats i Steg 1 för att vidareutveckla idén. I detta steg beskriver man hur arbetsmomentet utförs idag, samt vilka förändringar och konsekvenser som är kopplade till den nya idén. Man tittar också på specifika förutsättningar och möjliga kostnader, samt om ytterligare aktörer behöver involveras.",
  "En arbetsgrupp bildas med de aktörer som definierats i Steg 1 och 2, samt andra roller eller kompetenser som man anser nödvändiga (tex chefer, administration, kommunikation och IT). Målet är att vidareutveckla fördelarna med idén, specificera problem, behov och möjliga utmaningar vid implementeringen, samt att visualisera idén genom exempelvis flödesscheman, etc.",
  "Idén utvecklas inför senare anbudsprocess och implementering. Målet är framförallt att tydliggöra vilka konsekvenser idén kan få för varje specifik enhet i organisationen samt för andra intressenter, och att översätta detta till olika aspekter av den berörda verksamheten (ekonomi, vårdlogik, IT-system krav, säkerhet, osv)."
]

const steps = [
  {
    id: 0,
    textTitle: 'PROTOTYP 1:',
    text: 'En första idé definieras i allmänna termer i relation till ett visst sammanhang.',
    popUpText: 'Nu är det dags att utveckla en första enkel prototyp baserad på informationen som du har samlat på dig genom hela steg 1. Det kan du göra genom att tex rita en enkel ritning med papper och penna.',
    showPopUp: false,
    lillys: [
      {
        id: "0",
        description: "Hur skulle du beskriva idén? Vem kom på idén? Varför? Finns det ett problem? ",
        checked: false,
        top: "34%",
        left: "4%",
        isLarge: false,
        imageSrc: openLily,
        popUpText: "",
        showPopup: false
      },
      {
        id: "1",
        description: "Hur skulle du beskriva behovet? Vems är behovet? Vilket problem försöker du lösa?",
        checked: false,
        top: "21%",
        left: "55%",
        isLarge: false,
        imageSrc: openLily,
        popUpText: "",
        showPopup: false
    
      },
      {
        id: "2",
        description: "Vem kan bidra med kunskap och erfarenhet kring idén eller problemet som idén försöker lösa (glöm inte slutanvändare)? ",
        checked: false,
        top: "37%",
        left: "66%",
        isLarge: true,
        imageSrc: openLily,
        showPopup: false,
        popUpText: "Andra yrkesområden, avdelningar, äldre personer, anhöriga, andra organsiationer som tex FoUiS, Hjälpmedelscentralen osv."
      },
      {
        id: "3",
        description: "Har någon annan redan identifierat problemet och hittat en lösning? Vems behov har blivit tillfredställt?",
        checked: false,
        top: "55%",
        left: "17%",
        isLarge: true,
        imageSrc: openLily,
        showPopup: false,
        popUpText: "Sök internt och exernt, tex andra kommuner, FoUiS, SKR, Hjälpmedelscentralen osv."
      },
      {
        id: "4",
        description: "Finns det etiska ställningstaganden eller risker att ta hänsyn till? Vad kan gå fel?",
        checked: false,
        top: "15%",
        left: "18%",
        isLarge: false,
        imageSrc: openLily,
        showPopup: false,
        popUpText: ""
      },
      {
        id: "5",
        description: "Hur lång tid kommer det ta att utveckla idén? Kan vi vänta så länge?",
        checked: false,
        top: "56%",
        left: "51%",
        isLarge: false,
        imageSrc: openLily,
        showPopup: false,
        popUpText: ""
      }
    ]
    
  },
  {
    id: 1,
    textTitle: 'PROTOTYP 2:',
    text: 'Kort beskrivning av vad, vem, när, var, varför och hur?',
    popUpText: 'Nu är det dags att utveckla en något mer avancerad prototyp baserad på informationen som du har samlat på dig genom de första två stegen. Det kan du göra genom att tex rita en ritning på ett papper eller med dator eller klippa och klistra ihop olika material.',
    showPopUp: false,
    lillys: [
      {
        id: "0",
        description: "På vilket sätt vill vi att den nya idén ska förbättra arbetsmomentet? Vilket tekniskt och organisatoriskt stöd behöver vi och varför?",
        checked: false,
        top: '23%',
        left: '1%',
        isLarge: true,
        imageSrc: openLily,
        popUpText: "",
        showPopup: false,
    
        title: "Utveckla idén i samverkan",
        subtitle: "Fortsatta diskussioner för att vidareutveckla idén"
      },
      {
        id: "1",
        description: "Vilka önskade/oönskade effekter ser vi efter implementeringen? Effekt för vem?",
        checked: false,
        top: "12%",
        left: "18%",
        isLarge: true,
        showPopup: false,
    
        imageSrc: openLily,
        popUpText: "Fundera även på om någon annans arbete kommer att påverkas negativt av det nya arbetssättet."
      },
      {
        id: "2",
        description: "Hur utförs arbetsmomentet idag? Vilka problem eller utmaningar finns? För vem?",
        checked: false,
        top: '15%',
        left: '51%',
        isLarge: false,
        showPopup: false,
        

        imageSrc: openLily,
        popUpText: "",
        customSize: {
          height: "265px",
          width: "285px"
        }
      },
      {
        id: "3",
        description: "Omvärldsbevaka: Finns det någon annan som redan jobbar på ett liknande sätt och hur långt har de kommit?",
        checked: false,
        top: '25%',
        showPopup: false,
    
        left: '67%',
        isLarge: true,
        imageSrc: openLily,
        popUpText: ""
      },
      {
        id: "4",
        description: "Är samtliga relevanta roller (t.ex. slutanvändare) och kompetenser representerade i vidarerutveckligen av idén?",
        checked: false,
        top: "54%",
        left: "63%",
        showPopup: false,
    
        isLarge: true,
        imageSrc: openLily,
        popUpText: "Tänk över om ni behöver komplettera vilka som är involverade."
      },
      {
        id: "5",
        description: "Finns det några begränsningar eller problem vad gäller juridik, lagar eller regler?",
        checked: false,
        top: "59%",
        left: "47%",
        showPopup: false,
    
        isLarge: false,
        imageSrc: openLily,
        popUpText: ""
      },
      {
        id: "6",
        description: "Vilka förändringar eller aktiviteter krävs för att genomföra idén? Kostnader?",
        checked: false,
        top: "60%",
        left: "18%",
        showPopup: false,
    
        isLarge: false,
        imageSrc: openLily,
        popUpText: ""
      },
      {
        id: "7",
        description: "Vilka utför eller blir berörda av de tänkta arbetsmomentet?",
        checked: false,
        top: "51%",
        left: "3%",
        showPopup: false,
    
        isLarge: true,
        imageSrc: openLily,
        popUpText: "Fundera över om det finns andra, både inom och utanför organisationen (internt och externt), med liknande problem eller behov som skulle kunna dra nytta av den nya idén.",
        customSize: {
          height: "250px",
          width: "270px"
        }
      }
    ]
  },
  {
    id: 2,
    textTitle: 'PROTOTYP 3:',
    text: 'Detaljerad visualisering av arbetssättet och preliminära bedömningar av idéns värde och ev svårigheter för implementering.',
    popUpText: 'Nu är det dags att utveckla en visualiserad prototyp baserad på informationen som du har samlat på dig genom de första stegen. Det kan du göra tex med hjälp av en dator. ',
    showPopUp: false,
    lillys: [
      {
        id: "0",
        description: "Varför behöver vi det nya arbetssättet som prototyp 2 representerar? Vilket problem löser det? Vilka behov möter det? Hur vet vi att det är verkliga behov?",
        checked: false,
        top: "24%",
        left: "0%",
        showPopup: false,
    
        isLarge: true,
        imageSrc: openLily,
        popUpText: "Förslag: Klustra problemen och behoven för att få en bra överblick. Jämfört med verktyg som root cause analys denna fråga tar även upp behov och därmed fokuserar inte bara på nuvarande problem.",
        title: "Samla relevant kompetens och utse en arbetsgrupp",
        subtitle: "Målet är att fortsätta utveckla idén inom arbetsgruppen. Idén kan visualiseras genom tex flödesscheman, med olika datakällor osv",
        customSize: {
          height: "300px",
          width: "320px",
          leftDots: "150px"
        }
      },
      {
        id: "1",
        description: "Vilka svårigheter och utmaningar finns i samband med införandet av idén?",
        checked: false,
        top: "16%",
        left: "18%",
        showPopup: false,
    
        isLarge: false,
        imageSrc: openLily,
        popUpText: "Förslag: Genomförbarhetsanalys kan användas som verktyg."
      },
      {
        id: "2",
        description: "Hur kan vi beskriva arbetsmomentet som det utförs idag med tex. ett diagram, flödesschema eller annat sätt?",
        checked: false,
        top: '11%',
        left: '51%',
        showPopup: false,
    
        isLarge: false,
        imageSrc: openLily,
        popUpText: "Förslag: använda IT processmodeller men de tar inte hänsyn till att vissa uppgifter kan vara helhetliga (enhetliga??) och inte sekventiella. Designmetoder som användarresa eller liknande kan också vara en resurs för att beskriva det nuvarande arbetssättet. Fundera över vilka aktiviteterna, relationerna, resurserna, frekvenserna, de involverade personerna är",
        customSize: {
          height: "280px",
          width: "300px"
        }
      },
      {
        id: "3",
        description: "Hur kan vi beskriva och visualisera förändringarna som vi vill genomföra (med tex diagram, flödesschema eller annat sätt)?",
        checked: false,
        top: "28%",
        left: "63%",
        showPopup: false,
    
        isLarge: true,
        imageSrc: openLily,
      },
      {
        id: "4",
        description: "Har vi glömt att involvera någon mer som påverkas eller berörs på något sätt? Behöver vi komplettera arbetsgruppen med fler kompetenser/roller?",
        checked: false,
        top: "52%",
        showPopup: false,
    
        left: "55%",
        isLarge: true,
        imageSrc: openLily,
        popUpText: "Förslag: Använda Intressentanalys som verktyg.  Överväg att kontakta även andra organisationer som tex FoUiS, flera slutanvändare, företag osv",
        customSize: {
          height: "290px",
          width: "310px"
        }
      },
      {
        id: "5",
        description: "Vilken information finns tillgänglig för hur arbetsmomentet genomförs idag? Behövs mer information?",
        checked: false,
        top: "58%",
        showPopup: false,
    
        left: "20%",
        isLarge: false,
        imageSrc: openLily,
        popUpText: "Förslag: Använda Informationsinventering som verktyg ",
        customSize: {
          height: "270px",
          width: "290px"
        }
      }, {
        id: "6",
        description: "Vilka är de potentiella nyttorna med den nya idén? Vilka kommer att dra nytta av den?",
        checked: false,
        top: "55%",
        left: "5%",
        showPopup: false,
    
        isLarge: false,
        imageSrc: openLily,
        popUpText: "Förslag: Använda Angelägenhetsanalys som verktyg."
      }
    ]
  },
  {
    id: 3,
    text: 'Idén är nu beskriven utifrån verksamhetens perspektiv samt ekonomiska perspektiv.',
    popUpText: '',
    showPopUp: false,
    lillys: [
      {
        id: "0",
        description: "Beskriv ekonomiska kostnader och nyttor.",
        checked: false,
        top: "18%",
        left: "6%",
        showPopup: false,
    
        isLarge: false,
        imageSrc: openLily,
        popUpText: "Tänk på att den ekonomiska aspekten är en sak som bör tas hänsyn till, men att diskussionen även bör beröra kvalitativa nyttor",
        title: "Utveckla idén i samverkan",
        subtitle: "Fortsatta diskussioner för att vidareutveckla idén",
        customSize: {
          height: "230px",
          width: "250px",
          leftDots: "114px",
          topBtn: '60%'
        }
      },
      {
        id: "1",
        description: "Revidera listan över möjliga fördelar eller nyttor och  vilka användare som berörs av dem.",
        checked: false,
        top: "16%",
        left: "19%",
        isLarge: false,
        imageSrc: openLily,
        showPopup: false,
        customSize: {
          leftDots: "125px"
        },
    
        popUpText: "Tänk på att även andra externa parter som exempelvis FoUiS, användare i målgruppen, företag etc.,  kan dra nytta av detta."
      },
      {
        id: "2",
        description: "Kartlägg ytterligare vilka möjliga förändringar som krävs, svårigheter och konsekvenser (vad gäller arbetsmetoder, kvaliteten på tjänsten som tillhandahålls slutanvändaren osv.)",
        checked: false,
        top: "16%",
        left: "50%",
        isLarge: true,
        imageSrc: openLily,
        showPopup: false,
    
        popUpText: "Tänk på arbetsmetoder, kvaliteten på tjänsten som tillhandahålls slutanvändaren osv.",
        customSize: {
          height: "325px",
          width: "345px",
          leftDots: "157px",
          rightText: "69px",
          topBtn: '70%',
          textTop: "94px"

        }
      },
      {
        id: "3",
        description: "Fundera över om vi har missat att inkludera någon  relevant kompetens? Behöver vi revidera involverade parter? Till vem bör vi kommunicera vad?",
        checked: false,
        top: "22%",
        left: "69%",
        isLarge: true,
        showPopup: false,
    
        imageSrc: openLily,
        popUpText: "",
        customSize: {
          height: "305px",
          width: "325px",
          rightText: "68px",
          textTop: "94px"
        }
      },
      {
        id: "4",
        description: "Kan vi beskriva i detalj vilka konsekvenser och risker som kan uppkomma för organisationen  eller involverade enheter. Bör vi informera någon om dessa?",
        checked: false,
        top: "53%",
        left: "66%",
        isLarge: true,
        showPopup: false,
    
        imageSrc: openLily,
        popUpText: "Tänk på arbetsmetoder, kvaliteten på tjänsten som tillhandahålls slutanvändaren osv.",
        customSize: {
          height: "300px",
          width: "320px",
          leftDots: "147px"
        }
      },
      {
        id: "5",
        description: "Kan vi i detalj beskriva konsekvenser och risker för andra intressenter? Behöver vi informera dem om detta?",
        checked: false,
        top: "61%",
        left: "49%",
        isLarge: false,
        showPopup: false,
    
        imageSrc: openLily,
        popUpText: "",
        customSize: {
          height: "250px",
          width: "270px",
          textTop: "69px"
        }
      },
      {
        id: "6",
        description: "Kan vi i detalj beskriva konsekvenser och risker för  användarna? Behöver vi informera dem om dessa?",
        checked: false,
        showPopup: false,
    
        top: "58%",
        left: "18%",
        isLarge: true,
        imageSrc: openLily,
        popUpText: ""
      },
      {
        id: "7",
        description: "Är idén tillräckligt användarvänlig?",
        checked: false,
        top: "34%",
        left: "-2%",
        isLarge: false,
        showPopup: false,
    
        imageSrc: openLily,
        popUpText: "",
        customSize: {

          textTop: "94px"

        }
      },
      {
        id: "8",
        description: "Är idén fortfarande relevant?",
        checked: false,
        top: "58%",
        left: "3%",
        isLarge: false,
        showPopup: false,
    
        imageSrc: openLily,
        popUpText: ""
      }
    ]
  }
]







function CheckList() {

  const [currentStep, setCurrentStep] = useState(0);
  const [stepsEnd, setStepsEnd] = useState(steps);
  const [step0, setStep0] = useState(steps[0].lillys);
  const [step1, setStep1] = useState(steps[1].lillys);
  const [step2, setStep2] = useState(steps[2].lillys);
  const [step3, setStep3] = useState(steps[3].lillys);
  const [isDecision, setIsDecision] = useState(false);
  const [isIntroduction, setIsIntroduction] = useState(true);


  const updateState = (data: any, setData: any, lilly: any) => {
    setData([...data].map((object: { id: any; }) => {
      if (object.id === lilly.id) {
        return {
          ...object,
          checked: !lilly.checked,

        }
      }
      else return object;
    }))
  }

  const uncheckAll = (lilly: any[]) => {
    lilly.forEach(lil => {
      lil.checked = false
    });
    var currentStepData = getCurrentStepData(currentStep);
    console.log(currentStep);
    console.log(currentStepData);

    updateState(lilly, currentStepData.setData, lilly);

    //handleLillyClick(lilly)
  }

  const updateState2 = (data: any, setData: any, lilly: any) => {
    setData([...data].map((object: { id: any; }) => {
      if (object.id === lilly.id) {
        return {
          ...object,
          showPopup: !lilly.showPopup,
        }
      }
      else return object;
    }))
  }

  const onEndPopUp = (index : any) => {
    // https://stackoverflow.com/questions/52886181/setstate-update-array-value-using-index-in-react
    //https://stackoverflow.com/questions/29537299/react-how-to-update-state-item1-in-state-using-setstate

    let steps = [ ...stepsEnd ];
    steps[index] = {...stepsEnd[index], showPopUp: !stepsEnd[index].showPopUp};

    setStepsEnd(steps);
  }

  const handleLillyClick = (lilly: any) => {
    const currentStepData = getCurrentStepData()
    updateState(currentStepData.data, currentStepData.setData, lilly);
  };

  const handleLillyClick2 = (lilly: any) => {
    const currentStepData = getCurrentStepData()
    updateState2(currentStepData.data, currentStepData.setData, lilly);
  };

  const popup = (text: string) => {
    return (<div className="popup-container">
      {text}
    </div>)
  }

  const lillyCreator = (lilly: any) => {

    return (
      <div key={lilly.id}  className="lilly" data-name={lilly.checked}
        style={{
          opacity: lilly.checked ? "40%" : "100%",
          top: lilly.top, left: lilly.left,
          pointerEvents: 'none'

        }}>
        <img style={{
          height: lilly?.customSize?.height ? lilly.customSize.height : (lilly.isLarge === true ? "280px" : "250px"),
          width: lilly?.customSize?.width ? lilly.customSize.width : (lilly.isLarge === true ? "300px" : "270px")

        }} src={lilly.isLarge ? nufarL : nufarS} alt="" />
        {
          lilly.popUpText && 
          <div  style={{left: lilly?.customSize?.leftDots ? lilly.customSize.leftDots : '', pointerEvents: 'auto'}}
            onClick={()=> handleLillyClick2(lilly)} className="pop-up-btn">{horizontalDots}
            {lilly.showPopup && <div style={{ margin: '-110px 0px 0px 75px'}}> {popup(lilly.popUpText)} </div>}
          </div>
        }
        <div  style={{top: lilly?.customSize?.topBtn ? lilly.customSize.topBtn : '', pointerEvents: 'auto'}}
           className="button-lily" onClick={() => { handleLillyClick(lilly) }}>
          <img style={{
            height: "30px", width: "30px"
          }}
            alt="x"
            src={lilly.checked ? checkHover : checkAlb}
            onMouseOver={e => (e.currentTarget.src = lilly.checked ? checkAlb : checkHover)}
            onMouseOut={e => (e.currentTarget.src = lilly.checked ? checkHover : checkAlb)}
          />
        </div>
        <div style={{top: lilly?.customSize?.textTop ? lilly.customSize.textTop : '',
                    right: lilly?.customSize?.rightText ? lilly.customSize.rightText : '', pointerEvents: 'auto'
                  }} className="text-lily">{lilly.description} </div>
      </div>
    )
  }




  const circleCenter = (<div className="center-circle"></div>)

  const circleCenterDone = (<div className="center-circle-done">

    <div className="flower-container">{lotusFlower}</div>
    <div className="info-flower-container">
      <div className="flower-title">BRA JOBBAT!</div>
      <div onClick={()=> onEndPopUp(currentStep)} 
            className="pop-up-btn" 
            style={{top: '28px', right: '36%',textAlign: 'center'}}
      >
              {stepsEnd[currentStep].popUpText !== '' ? horizontalDots : <span></span>} 
              {stepsEnd[currentStep].showPopUp && <div style={{margin: '-230px 0px 0px 145px'}}> {popup(stepsEnd[currentStep].popUpText)}</div> }
      </div>
      {/* nu stiu cum sa fac sa fie floare deasupra la nufar */}
      <img style={{
          height: "400px",
          width: "400px",
          position: 'absolute',
          top: '-397%',
          right: '-0%',
          zIndex: -1

        }} src={nufarEnd} alt="" >
          
        </img>

      <div className="flower-text">
        <div>{steps[currentStep]?.textTitle}</div>
        {steps[currentStep].text}
      </div>
      <button
        onClick={() => { setIsDecision(true); }}
        style={{  position: 'absolute', top: '460%', left: '27%', width: '175px', transform: 'translateY(112px)'  }}
        className="nav-btn">
        BESLUTSPUNKT
      </button>

    </div>
  </div>);

  const back = (): any => {
    setIsIntroduction(true);
    if (isDecision) setIsDecision(false);
    if (currentStep > 0) setCurrentStep(currentStep - 1)
  }

  const next = (): any => {
    setIsIntroduction(true);
    if (isDecision) setIsDecision(false);
    if (currentStep < buttons.length - 1) setCurrentStep(currentStep + 1)
  }

  const history = useHistory();
  const goToRoute = useCallback((path) => { history.push(path); }, [history]);

  const decisionPoint = (

    <div className="decision">
      <div className="decision-row">
        <div style={{ display: 'flex', alignItems: "center" }}>

          <button onClick={() => {setIsDecision(false); uncheckAll(getCurrentStepData(currentStep).data);
                                      }} className="nav-btn decision-btn">{leftIcon}OMARBETA</button>
          <div className="decision-center">
            <div className="decision-card">
              <div className="decision-title">BESLUTSPUNKT </div>
              {doubleArrow}
              <div className="decision-text">
                Fortsätta med idén, avsluta idén, sammanfoga idén med annan idé (omarbeta).
              </div>
            </div>
            <button onClick={() => goToRoute('/')} style={{ margin: '0px auto' }} className="nav-btn decision-btn">AVSLUTA</button>

          </div>
          {currentStep !== 3 
                  ?
                    <button onClick={() => { setIsDecision(false); next() }} 
                      className="nav-btn decision-btn">FORTSÄTTA {rightIcon}
                    </button>
                  : 
                  <div style={{position: 'relative'}}>
                    <img style={{
                      height: "250px",
                      width: "270px"
            
                    }} src={nufarS} alt="" 
                    
                    >
                      
                      </img>
                    <div className="text-lily">
                          <div>Fortsätta:</div> 
                          <div style={{paddingTop: '10px'}}>
                          dags att gå vidare till 
                          implementeringsfasen. 
                          </div>
                    </div>

                  </div>

          }


        </div>
      </div>
    </div>
  );


  const switchSteps = () => {
    switch (currentStep) {
      case 0:
        return renderStep(step0);
      case 1:
        return renderStep(step1);
      case 2:
        return renderStep(step2);
      case 3:
        return renderStep(step3);
      default:
        return 1;
    }
  }

  const getCurrentStepData = (stepNumber?: any, test?: any): any => {
    var step = typeof(stepNumber) === 'number' ? stepNumber : currentStep;
    
    switch (step) {
      case 0: return { data: step0, setData: setStep0 };
      case 1: return { data: step1, setData: setStep1 };
      case 2: return { data: step2, setData: setStep2 };
      case 3: return { data: step3, setData: setStep3 };
      //default: return { data: step0, setData: setStep0 };
    }
  }


  const isCurrentStepDone = (stepNumber?: any): boolean => {

    const allChecked = (lilly: any) => lilly.checked === true;
    return getCurrentStepData(stepNumber).data.every(allChecked);
  }

  const listButtons = buttons.map((button) =>
    <button style={{  
                      opacity: isCurrentStepDone(button.id) && button.id !== currentStep ? "30%" : "100%",
                      backgroundColor: isCurrentStepDone(button.id) ? '#72B1B4' : ''
                    }}
      onClick={() => {
        setIsDecision(false);
        setIsIntroduction(true);
        setCurrentStep(button.id)
      }}
      className={`step-button ${button.id === currentStep ? 'selected-step-btn  ' : ''}`}>
      {button.name}
    </button>
  );

  const renderStep = (lilly: any) => {
    console.log('sa vaz lily', lilly)


    const listLillys = lilly.map((lilly: any) => {
      return (
        <div key={lilly.id}>
          {lillyCreator(lilly)}
        </div>)
    })

    const introduction = (
      <div className="decision">
        <div className="decision-row">
          <div style={{ display: 'flex', alignItems: "center" }}>

            <div className="decision-center">
              <div className="decision-card" style={{ width: "500px" }}>
                <div className="decision-text">
                  {stepIntroduction[currentStep]}
                </div>
              </div>
              <button onClick={() => setIsIntroduction(false)} 
                style={{ margin: '0px auto',
                    color: 'white', 
                    backgroundColor: '#72B1B4',
                    border: '0px solid black',
                    padding: '7px 15px' 
                  }} 
                className="nav-btn">BÖRJA {buttons[currentStep].name}
              </button>
            </div>
          </div>
        </div>
      </div>
    )

    const stepFlow = (
      <span>
        { isDecision ? decisionPoint :
          (isCurrentStepDone() ? circleCenterDone : circleCenter)}
        {isDecision ? null : listLillys}
      </span>
    )

    return (
      isIntroduction ? introduction : stepFlow
    )
  }

  const titleArea = (
    <div id="title-area">
      <div style={{margin: '-30px 0px'}}>
        <div className="step-title">STEG {currentStep + 1}:</div>
        <div className="subtitle-step">{stepTitle[currentStep]}</div>
        <div className="under-subtitle">{stepDescription[currentStep]}</div>
      </div>
    </div>
  )



  return (
    <div className={`checklist-container ${isDecision ? 'bg-done' : 'bg-step'}`}>
      {isDecision ? null : titleArea}

      <div className="footer-buttons">
        <button
          style={{ visibility: (currentStep !== 0 && currentStep !== 3) ? 'visible' : 'hidden', width: '230px' }}
          onClick={() => back()}
          className="nav-btn">
          {leftIcon}FÖREGÅENDE STEG
        </button>

        {listButtons}

        <button onClick={() => next()}
          style={{marginLeft: '7px', width: '170px', 
          visibility: (currentStep !== 3) ? 'visible' : 'hidden' }}
          className="nav-btn">
          NÄSTA STEG {rightIcon}
        </button>
      </div>

      <div id="right-area">
        <button className="btn-info" onClick={() => goToRoute('/introduktion')}>INTRODUKTION</button>
        <button className="btn-info" onClick={() => goToRoute('/hurfunkardet')}>HUR FUNKAR DET</button>

      </div>

      {switchSteps()}

    </div>
  );
}

export default CheckList;
